var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIHiContrast01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 171,
    viewBox: "0 0 84 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.21094,
    width: 80,
    height: 166.667,
    rx: 12.5,
    fill: "#F4F6FA",
    stroke: "#D2D6DC",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.25,
    y: 3.46094,
    width: 77.5,
    height: 164.167,
    rx: 11.25,
    fill: "#F4F6FA",
    stroke: "#10141A",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.168,
    y: 7.21094,
    width: 21.6667,
    height: 6.66667,
    rx: 3.33333,
    fill: "#10141A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9951 81.0469H21.3545V83.0859H25.3447V84.1934H21.3545V86.3906C22.5439 86.3848 23.5312 86.3525 24.3164 86.2939C25.1016 86.2354 25.8955 86.127 26.6982 85.9688L26.8389 87.1113C25.9834 87.2754 25.1426 87.3838 24.3164 87.4365C23.4902 87.4893 22.3916 87.5156 21.0205 87.5156H20.0361V79.9219H25.9951V81.0469ZM32.5693 94.4238H31.2158V90.3457H21.9697V89.2031H32.5693V94.4238ZM32.5693 88.4648H31.251V78.8145H32.5693V88.4648ZM29.5283 88.3594H28.1924V84.0703H26.083V82.9102H28.1924V79.1484H29.5283V88.3594ZM42.6416 81.0996C42.6416 81.9492 42.9258 82.7725 43.4941 83.5693C44.0684 84.3604 44.8037 85.0342 45.7002 85.5908C46.5967 86.1416 47.5049 86.502 48.4248 86.6719L47.792 87.832C46.9951 87.6445 46.21 87.3398 45.4365 86.918C44.6631 86.4961 43.9688 85.9746 43.3535 85.3535C42.7383 84.7324 42.2666 84.0498 41.9385 83.3057C41.6104 84.0439 41.1387 84.7236 40.5234 85.3447C39.9082 85.9658 39.2139 86.4902 38.4404 86.918C37.6729 87.3398 36.8877 87.6445 36.085 87.832L35.4521 86.6719C36.3721 86.4902 37.2773 86.127 38.168 85.582C39.0586 85.0312 39.7852 84.3604 40.3477 83.5693C40.916 82.7783 41.2002 81.9551 41.2002 81.0996V79.9043H42.6416V81.0996ZM49.1631 92.2969H34.8545V91.1543H49.1631V92.2969ZM63.0674 88.377H52.2568V80.1504H62.8916V81.3105H53.6631V83.6309H62.5576V84.7383H53.6631V87.252H63.0674V88.377ZM64.7197 92.3848H50.4111V91.2422H64.7197V92.3848Z",
    fill: "#B4B8BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIHiContrast01);
export default __webpack_public_path__ + "static/media/i_hi_contrast_01.6b79311b3a455dd15578d112080538c6.svg";
export { ForwardRef as ReactComponent };